<template>
  <div class="registerConsultant">
         <!-- <TheNavigationPanel/> -->
         <v-container>
            <v-toolbar flat color="#F0FFEA" height="30" >
            <v-toolbar-title style="color:#62AE32" class="headline">Register Consultant</v-toolbar-title>
        </v-toolbar>

         <v-snackbar v-model="snackbar" :timeout="4000" top color="success">
            <span>You've successfully registered a new Consultant. Password has been sent to the email provided.</span> 
                <v-btn text color="white" @click="snackbar = false">Close</v-btn>
        </v-snackbar>


           <v-card class="ml-4 my-9" color="#F0FFEA" max-width="500" flat> 
               <v-form ref="form">
                <v-row no-gutters>
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                    <span style="font-size:13px; color:#615D5D">Firstname</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            label="Adeleke"
                            type="text"
                            solo
                            flat
                            dense
                            v-model="firstname"
                            class="black--text"
                            :rules="fnameRules"
                        ></v-text-field>
                    </v-col>
                </v-row>

                  <v-row no-gutters>
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                    <span style="font-size:13px; color:#615D5D">Lastname</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            label="Abiodun"
                            type="text"
                            solo
                            flat
                            dense
                            v-model="lastname"
                            class="black--text"
                            :rules="lnameRules"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-row no-gutters>
                    <v-col class="mt-2" cols="12" md="4" sm="6">
                        <span style="font-size:13px; color:#615D5D">Username</span>
                        
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            label="jendel"
                            type="text"
                            solo
                            flat
                            dense
                            v-model="username"
                            class="black--text"
                            :rules="usernameRules"
                            @change="isAvailable()"
                        ></v-text-field>
                    </v-col>
                </v-row >
               
                <v-row no-gutters>
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Phone No</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            label="08100000000"
                            type="text"
                            solo
                            flat
                            dense
                            v-model="contact"
                            class="black--text"
                            :rules="phoneRules"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col class="mt-2" cols="12" md="4" sm="6">
                        <span style="font-size:13px; color:#615D5D">Email</span>
                        
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            label="jendel@gmail.com"
                            type="email"
                            solo
                            flat
                            dense
                            v-model="email"
                            class="black--text"
                            :rules="emailRules"
                        ></v-text-field>
                    </v-col>
                </v-row >
                

                 <v-layout class="my-4">
                <v-spacer></v-spacer>
                <v-btn color="#08911b" :loading="loading"  class="white--text btn-style"  v-on:click="Register()">
                    Make Consultant</v-btn>
            </v-layout>

            </v-form>
            </v-card>

         </v-container>
  </div>
    
</template>


<script>
export default {
    components: {
    },
    data(){
        return{
            firstname: '',
            lastname: '',
            contact: '',
            snackbar: false,
            email: '',
            username: '',
            go:'',
            loading: false,
            fnameRules:[v => !!v || 'Firstname is required'],
            lnameRules:[v => !!v || 'Lastname is required'],
            phoneRules:[v => !!v || 'Phone number is required',
                v => v.length <= 11 || 'Phonenumber must be less than 11 characters',
                v => {
                    const pattern = /^-?[0-9]+(.[0-9]{1-7})?$/;
                    return pattern.test(v) || 'Numbers only'
                } 
            ],
            emailRules:[v => !!v || 'Email is required',
                        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
            ],
            addressRules:[v => !!v || 'Address is required'],
            genderRules:[v => !!v || 'Gender is required'],
            usernameRules:[v => !!v || 'Username is required'],


        }
    },
    methods:{
        // check if username is available
        isAvailable(){
            if (this.username){
            this.$store.dispatch('isConsultantAvailable', {username:this.username})
            .then(data=>{
                if (data===false){
                    this.usernameRules=['username name is not available']
                }else{
                    this.usernameRules=[v => !!v || 'Username is required']
                    this.go = 'true'
                }
            })
            }
            
        },
        Register(){
        if(this.$refs.form.validate() && this.go==="true"){
            this.loading = true
            this.$store.dispatch("registerConsultant", {
                "firstName": this.firstname,
                "lastName": this.lastname,
                "phoneNumber": this.contact,
                "email": this.email,
                "consultantUsername": this.username,
                "addedBy": this.$store.state.community.logindetails.consultant_id
                })
            .then((success)=>{
                console.log(success);
                this.loading = false
                this.firstname = '',
                this.lastname = '',
                this.contact = '',
                this.email = '',
                this.username = '',
                this.snackbar = true;
            })
            .catch((error)=>{
                console.log(error);
            });
        }
    },
  }
    
}
</script>


<style scoped>
.title-color{
  color : #62ae32;
}
.registerConsultant{
    background-color: #f0ffea;
    height: 100%;
    background-size: cover;
}

</style>